// extracted by mini-css-extract-plugin
export var container = "_7u-0";
export var error = "_7u-9";
export var label = "_7u-5";
export var light = "_7u-6";
export var md = "_7u-3";
export var sm = "_7u-2";
export var thin = "_7u-8";
export var thinBold = "_7u-7";
export var vertical = "_7u-4";
export var xs = "_7u-1";